export default __webpack_public_path__ + "static/media/refresh.fef82a6e.svg";